import { useRef } from 'react';
import { avoidBreakAfter } from '@provider/print';
import { useKatex } from '@utils/react';
import { OpgaveKompleksetSpeechSynthesis } from '../atom.speech-synthesis/_speech-synthesis.js';
import { media, textContent, readOutLoudButtonWrapper } from './shared.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TextMedia(props) {
  const ref = useRef(null);
  useKatex(ref);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: media,
    ...(props.avoidBreakAfter ? avoidBreakAfter() : undefined),
    children: [/*#__PURE__*/jsx("div", {
      className: textContent,
      children: props.node.text
    }), props.withReadOutLoudButton && /*#__PURE__*/jsx(OpgaveKompleksetSpeechSynthesis, {
      id: props.introductionId,
      defaultTooltip: "L\xE6s beskrivelsen op",
      wrapperClassName: readOutLoudButtonWrapper
    })]
  });
}

export { TextMedia };
//# sourceMappingURL=text.js.map
